import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import logo from '../../images/logo.png';
import { ROLE_PROFESSOR } from '../../constants/roles';

const AuthPage = () => {
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const role = useSelector((state) => state.auth.user?.role);

    if (isAuthenticated) {
        return <Navigate to={role === ROLE_PROFESSOR ? '/espace-professeur/vue-ensemble' : '/accueil'} replace />;
    }

    return (
        <div style={{
            minHeight: '100vh', background: '#0A1226',
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center',
            padding: '32px 24px',
            WebkitFontSmoothing: 'antialiased',
        }}>
            <div style={{ width: '100%', maxWidth: 360, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {/* Logo */}
                <img src={logo} alt="Trading Series" style={{ height: 56, width: 'auto' }} />
                <p style={{
                    marginTop: 16, fontSize: 15, color: '#97A4BE',
                    textAlign: 'center', lineHeight: 1.6,
                }}>
                    Connecte-toi ou crée ton compte pour débuter l'aventure.
                </p>

                <div style={{ width: '100%', marginTop: 40, display: 'flex', flexDirection: 'column', gap: 12 }}>
                    <Link to="/connexion" style={{ textDecoration: 'none', width: '100%' }}>
                        <button style={{
                            width: '100%', height: 54, borderRadius: 16,
                            background: 'linear-gradient(180deg, #ffffff 0%, #e3e8f1 100%)',
                            color: '#0A1226', border: 'none', cursor: 'pointer',
                            fontWeight: 700, fontSize: 15,
                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 9,
                            boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.9), 0 10px 24px -10px rgba(0,0,0,0.6)',
                        }}>
                            Se connecter
                        </button>
                    </Link>
                    <Link to="/inscription" style={{ textDecoration: 'none', width: '100%' }}>
                        <button style={{
                            width: '100%', height: 54, borderRadius: 16,
                            background: 'rgba(255,255,255,0.06)',
                            color: '#F2F5FB', border: '1px solid rgba(255,255,255,0.09)',
                            cursor: 'pointer', fontWeight: 700, fontSize: 15,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                            Créer un compte
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default AuthPage;
